import { Component, ChangeDetectorRef, OnInit } from '@angular/core';
import { CustomerService } from "../../services/customer";
import { CustomerAddressService } from "../../services/customeraddress";
import { CustomerAddress } from '../../interfaces/customeraddress.interface';
import { Customer } from '../../interfaces/customer.interface';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customeraddress',
  imports: [],
  templateUrl: './customeraddress.html',
  styleUrl: './customeraddress.css'
})
export class CustomerAddressComponent implements OnInit {
  custcode: string = '';
  public customeraddresses: CustomerAddress[] = [];
  public selectedCustomerAddress: CustomerAddress = {} as CustomerAddress;

  constructor(  public customerService: CustomerService, 
                private customerAddressService: CustomerAddressService, 
                private cdr: ChangeDetectorRef, 
                private router: Router) {  }

    ngOnInit(): void {
        
        this.getCustomeraddresses();
      } 

   public async getCustomeraddresses(): Promise<void> {
 
        if (this.customerService.selectedCustomer.customercode == null)
        {
            this.custcode = this.customerAddressService.editcustomeraddress.customercode;
        }
        else
        {
            this.custcode = this.customerService.selectedCustomer.customercode;
        }
        if (this.custcode == null || this.custcode.trim() === '')
        {
          this.router.navigateByUrl('customer');
          return;
        }
        try {
        this.customeraddresses = await this.customerAddressService.getCustomeraddresses(this.custcode);
         this.cdr.detectChanges();
        } catch (error) {
          console.error('getcustomers',error);
        }
    }

    onAdd(customer: Customer){
      this.customerAddressService.customer = customer;
      this.router.navigateByUrl('addcustomeraddress')
    }

    onEdit(customeraddress: CustomerAddress){
        this.customerAddressService.editcustomeraddress = customeraddress;
        this.router.navigateByUrl('editcustomeraddress')
    }

 async deleteCustomeraddress(customeraddress: CustomerAddress): Promise<void> {
        const confirmation = window.confirm(`Are you sure you want to delete ${customeraddress.addressline1}?`);
      if (!confirmation) {
       return;
      }
        try
        {
          await this.customerAddressService.delete(customeraddress.id)
          this.getCustomeraddresses();
           this.cdr.detectChanges();
        } catch (error) {
          console.error('deletecustomeraddresse',error);
        }
 
      }


    goBack(): void {
    this.router.navigateByUrl('customer');
    }

  }
